import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';

import logo01 from '../../assets/logos/cetificated.png';
import { Link } from 'react-router-dom';

function Login() {
  const [password, setPassword] = useState('');
  const [repassword, setRepassword] = useState('');
  const [error, setError] = useState('');
  const [tokenRecovery, setTokenRecovery] = useState('');

  const { token, currentUser } = useContext(AuthContext);

  const handleRecovery = async () => {
    const lang = 'es';

    if (!password || !repassword) {
      setError('Contraseña y repetir contraseña son requeridos');
      return;
    }

    if (password !== repassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/auth/reset-password`,
        { password, token: tokenRecovery }
      );
      if (response.status === 200) {
        alert(response.data.message);
        // refirect to login
        window.location.href = '/';
      } else {
        alert(response.data.message);
      }
      setError('');
    } catch (error) {
      const { response } = error;
      setError('');
      alert(response.data.message);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    setTokenRecovery(token);
  }, []);

  return (
    <>
      <div
        className="container-fluid bg-sen d-flex flex-column"
        style={{ minHeight: 'calc(100vh - 65px)' }}
      >
        <div className="row justify-content-center align-items-center flex-grow-1">
          <div className="col-12 col-md-4 col-lg-4 login">
            <div className="text-center">
              <img src={logo01} alt="Logo 1" className="logo mb-2" />
              <div className="clearfix"></div>
              <h2>Resetear Contraseña</h2>
              <div className="text-start mb-2">
                Ingresa tu nueva contraseña 2 veces para restablecerla.
              </div>
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text bg-transparent border-end-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                type="password"
                className="form-control bg-transparent border-start-0"
                id="password"
                placeholder="Contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text bg-transparent border-end-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                type="password"
                className="form-control bg-transparent border-start-0"
                id="repassword"
                placeholder="Repetir Contraseña"
                value={repassword}
                onChange={e => setRepassword(e.target.value)}
              />
            </div>
            <div className="text-end">
              <button
                type="button"
                className="btn btn-dark btn-login mt-1"
                onClick={handleRecovery}
              >
                <span className="small">ENVIAR</span>
              </button>
            </div>
            {error && <p className="text-end">{error}</p>}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
